import React from 'react';
import LogoPreview from './LogoPreview';
import UploadLogo from './UploadLogo'
import './index.scss';

const UpdateLogo = () => {

	return (
		<div className='update-logo-wrapper'>
			<div className='row-blc d-flex align-items-center'>
				<div className='left-col'>
					<UploadLogo />
				</div>
				<div className='right-col'>
					<LogoPreview />
				</div>
			</div>
		</div>
	);
}

export default UpdateLogo;